"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
exports.RichText = function (_a) {
  var field = _a.field,
    tag = _a.tag,
    editable = _a.editable,
    otherProps = __rest(_a, ["field", "tag", "editable"]);
  if (!field || !field.editable && !field.value) {
    return null;
  }
  var htmlProps = __assign({
    dangerouslySetInnerHTML: {
      __html: field.editable && editable ? field.editable : field.value
    }
  }, otherProps);
  return react_1.default.createElement(tag || 'div', htmlProps);
};
exports.RichText.propTypes = {
  field: prop_types_1.default.shape({
    value: prop_types_1.default.string,
    editable: prop_types_1.default.string
  }).isRequired,
  tag: prop_types_1.default.string,
  editable: prop_types_1.default.bool
};
exports.RichText.defaultProps = {
  tag: 'div',
  editable: true
};
exports.RichText.displayName = 'RichText';